/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_A5Inputs */

const en_fw_faq_a5 = /** @type {(inputs: Fw_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. A live-action TV drama was announced on October 10, 2026, for broadcast on Fuji TV in 2027.`)
};

const zh_fw_faq_a5 = /** @type {(inputs: Fw_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有。2026 年 10 月 10 日宣布真人电视剧，预定 2027 年在富士电视台播出。`)
};

/**
* | output |
* | --- |
* | "Yes. A live-action TV drama was announced on October 10, 2026, for broadcast on Fuji TV in 2027." |
*
* @param {Fw_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_a5 = /** @type {((inputs?: Fw_Faq_A5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_A5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_a5(inputs)
	return zh_fw_faq_a5(inputs)
});
export { fw_faq_a5 as "fw.faq.a5" }